import React from 'react';
import { Avatar } from 'antd';
import { DefaultAvatar } from '../icons';
import './BandInfoLockup.css';

export interface BandMember {
    name: string;
    avatarUrl?: string;
}

export interface BandInfoLockupProps {
    /** Band display name */
    bandName: string;
    /** Band avatar image URL */
    imageUrl?: string;
    /** List of band members to display in "With" row */
    bandMembers?: BandMember[];
    /** Additional CSS class */
    className?: string;
    /** Click handler */
    onClick?: () => void;
}

export const BandInfoLockup: React.FC<BandInfoLockupProps> = ({
    bandName,
    imageUrl,
    bandMembers = [],
    className = '',
    onClick,
}) => {
    return (
        <div className={`band-info-lockup ${className}`} onClick={onClick} role={onClick ? 'button' : undefined}>
            {imageUrl && (
                <img
                    className="band-info-lockup__avatar"
                    src={imageUrl}
                    alt={bandName}
                />
            )}
            <div className="band-info-lockup__text">
                <h3 className="band-info-lockup__name">{bandName}</h3>
                {bandMembers.length > 0 && (
                    <div className="band-info-lockup__with">
                        <Avatar.Group size="small" max={{ count: 3 }}>
                            {bandMembers.map((member, index) => (
                                <Avatar
                                    key={index}
                                    src={member.avatarUrl}
                                    size="small"
                                    icon={!member.avatarUrl ? <DefaultAvatar size={16} /> : undefined}
                                />
                            ))}
                        </Avatar.Group>
                        <span className="band-info-lockup__with-text">
                            With {bandMembers[0]?.name} and more...
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};
